import { render } from "./MenuFrequencyModal.vue?vue&type=template&id=287b456c"
import script from "./MenuFrequencyModal.vue?vue&type=script&lang=js"
export * from "./MenuFrequencyModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__